<template>
    <div class="md-cta-sc row" :style="{ marginBottom }">
        <banner
            ref="banner"
            :class="{
                'mg-container': !fullColumn,
                'mobile-no-margin': mobileNoMargin
            }"
            :style="bannerStyle"
            type="single"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :maskOption="maskOption"
        >
            <media-content
                :class="{ showLayer: showOpacityLayer }"
                :style="
                    showOpacityLayer
                        ? { width: `calc(100% - ${2 * HorizontalMargin}px)` }
                        : {}
                "
                type="text"
                :title="title"
                :titleSize="32"
                subTitle=""
                :subTitleSize="18"
                :showShadow="false"
            >
                <a
                    v-if="buttons.length"
                    :href="
                        buttons[0].type === 'callback' ? null : buttons[0].link
                    "
                    class="button"
                    @click="showRegisterPop(buttons[0])"
                    rel="noopener noreferrer"
                    :target="buttons[0].target || '_blank'"
                    :aria-label="getButtonLabel(buttons[0])"
                    :style="getStyle(buttons[0])"
                >
                    <span>{{ getButtonLabel(buttons[0]) }}</span>
                    <i class="iconfont icon-next-big"></i>
                </a>
                <div
                    v-if="showOpacityLayer"
                    class="content-mask"
                    :style="{ backgroundColor: contentColor }"
                ></div>
            </media-content>
        </banner>
    </div>
</template>

<script>
import { getButtonHtmlStyle } from '@/common/utils/decode-html';
import common from '../index';
export default {
    data: function() {
        return {
            maskOption: {
                showMask: true,
                maskColor: 'rgba(32, 36, 55, 0.15)'
            }
        };
    },
    mixins: [common],
    methods: {
        getButtonLabel(button) {
            let text =
                button.label ||
                button.text ||
                (button.textOption && button.textOption.text) ||
                '';
            return text.replace(/<[^>]*>/g, '');
        },
        getStyle(button) {
            let temp = {
                color: button.textColor,
                backgroundColor: button.color,
                borderColor: button.borderColor
            };
            return {
                ...temp,
                ...getButtonHtmlStyle(button)
            };
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-cta-sc.row {
    .banner {
        flex-direction: column;
    }
    .media-content {
        flex: 1;
        position: relative;
        width: 1000px;
        max-width: calc(100% - 40px);
        padding: 0;
        &.showLayer {
            width: calc(100% - 160px);
            max-width: none;
            min-width: 600px;
            padding: 20px;
        }
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .media-info {
            flex: 1;
            margin-right: 20px;
        }
        .title-text {
            width: 100%;
            padding: 0;
            text-align: left;
            .media-title {
                font-size: 32px;
                line-height: 1.25;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                @include webkitBox(3);
            }
            .media-subtitle {
                font-size: 18px;
                line-height: 1.2;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                margin-top: 10px;
            }
        }
        .button {
            @include color-button-hover();
            flex: none;
            min-width: 210px;
            height: 50px;
            border-radius: 2px;
            padding: 0 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            font-family: var(--mg-button-font);
            @include color-button();
            .iconfont {
                margin-left: 15px;
                font-size: 12px;
                margin-top: 3px;
            }
        }
        .content-mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: -1;
        }
        @include media-800 {
            max-width: calc(100% - 30px);
            &.showLayer {
                max-width: 100%;
                min-width: 320px;
            }
            flex-direction: column;
            justify-content: center;
            .media-info {
                width: 100%;
                margin-right: 0;
                flex: none;
            }
            .title-text {
                text-align: center;
            }
            .button {
                margin-top: 20px;
            }
        }
        @include media-600 {
            .title-text {
                .media-title {
                    font-size: 24px;
                }
                .media-subtitle {
                    font-size: 14px;
                }
            }
            .button {
                min-width: 180px;
                font-size: 16px;
                height: 40px;
            }
        }
    }
}
</style>
